import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Layout.vue'
import { useUserStoreHook } from '@/store/modules/user'
import { message } from '@/utils'
import AdminLayout from '@/admin/layout/index.vue'
import { UserRoleEnum } from '@/types/constantsEnum'
// 基础路由
export const constantRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [
      {
        path: 'home',
        name: 'Home',
        component: () => import('@/views/home/index.vue'),
        meta: { title: '首页', level: 0 },
      },
    ],
  },
  {
    path: '/login',
    component: () => import('@/views/login/index.vue'),
    meta: { title: '登录', level: 1 },
  },
  {
    path: '/html',
    component: () => import('@/views/html/index.vue'),
    meta: { title: 'HTML', level: 1 },
  },
  {
    path: '/music',
    component: Layout,
    children: [
      {
        path: '/music',
        name: 'Music',
        component: () => import('@/views/music/index.vue'),
        meta: { title: '音乐创作', level: 1 },
      },
    ],
  },

  {
    path: '/voice',
    component: Layout,
    children: [
      {
        path: '',
        name: 'Voice',
        component: () => import('@/views/voice/index.vue'),
        meta: { title: '声线克隆', level: 2 },
      },
    ],
  },
  {
    path: '/ai',
    component: Layout,
    children: [
      {
        path: '',
        name: 'AI',
        component: () => import('@/views/ai/index.vue'),
        meta: { title: 'AI声音调整', level: 2 },
      },
    ],
  },
  {
    path: '/space',
    component: Layout,
    children: [
      {
        path: '',
        name: 'Space',
        component: () => import('@/views/space/index.vue'),
        meta: { title: '我的空间', roles: ['user'], level: 2 },
      },
    ],
  },
  {
    path: '/user',
    component: Layout,
    redirect: '/user/profile',
    children: [
      {
        path: 'profile',
        name: 'userProfile',
        component: () => import('@/views/user/index.vue'),
        meta: { title: '个人资料', roles: ['user'], level: 2 },
      },
    ],
  },
  {
    path: '/news',
    component: Layout,
    children: [
      {
        path: '',
        name: 'News',
        component: () => import('@/views/news/index.vue'),
        meta: { title: '新闻通知', level: 2 },
      },
    ],
  },
  {
    path: '/news/html',
    component: () => import('@/views/news/html.vue'),
    meta: { title: '新闻详情', level: 2 },
  },
  // {
  //   path: '/mv',
  //   component: Layout,
  //   children: [
  //     {
  //       path: '',
  //       name: 'MV',
  //       component: () => import('@/views/mv/index.vue'),
  //       meta: { title: 'MV创作', level: 1 },
  //     },
  //   ],
  // },
  {
    path: '/mv/edit',
    component: Layout,
    children: [
      {
        path: '',
        name: 'MVEdit',
        component: () => import('@/views/mvCreate/edit.vue'),
        meta: { title: '视频编辑', level: 1 },
      },
      {
        path: 'list',
        name: 'MVCreateList',
        component: () => import('@/views/mvCreate/index.vue'),
        meta: { title: '视频列表', level: 1 },
      },
      // {
      //   path: ':projectId',
      //   name: 'MVEditWithProject',
      //   component: () => import('@/views/mvCreate/edit.vue'),
      //   meta: { title: '视频编辑', level: 1 },
      // },
    ],
  },
  {
    path: '/mv/edit/:projectId?',
    name: 'MVEditWithProject',
    component: () => import('@/views/mvCreate/edit.vue'),
    meta: { title: '视频编辑', level: 1 },
  },
  // {
  //   path: '/about',
  //   component: Layout,
  //   children: [
  //     {
  //       path: '',
  //       name: 'About',
  //       component: () => import('@/views/about/index.vue'),
  //       meta: { title: '关于我们' },
  //     },
  //   ],
  // },
  {
    path: '/admin',
    component: AdminLayout,
    redirect: '/admin/index',
    meta: { roles: ['admin', 'operationStaff'] },
    children: [
      {
        path: 'index',
        name: 'adminIndex',
        component: () => import('@/admin/index/index.vue'),
        meta: { title: '首页', roles: ['admin', 'operationStaff'] },
      },
      {
        path: 'user',
        name: 'adminUser',
        component: () => import('@/admin/user/index.vue'),
        meta: { title: '用户管理', roles: ['admin', 'operationStaff'] },
      },
      {
        path: 'integral',
        name: 'adminIntegral',
        component: () => import('@/admin/Integral/index.vue'),
        meta: { title: '积分管理', roles: ['admin', 'operationStaff'] },
      },
      {
        path: 'integral/record',
        name: 'adminIntegralRecord',
        component: () => import('@/admin/integralRecord/index.vue'),
        meta: { title: '积分记录', roles: ['admin', 'operationStaff'] },
      },
      {
        path: 'integral/add',
        name: 'adminIntegralAdd',
        component: () => import('@/admin/Integral/userAddIntegral.vue'),
        meta: { title: '添加积分', roles: ['admin'] },
      },
      {
        path: 'music',
        name: 'adminMusic',
        component: () => import('@/admin/music/index.vue'),
        meta: { title: '音乐管理', roles: ['admin', 'operationStaff'] },
      },
      {
        path: 'voice',
        name: 'adminVoice',
        component: () => import('@/admin/voice/index.vue'),
        meta: { title: '声线克隆', roles: ['admin', 'operationStaff'] },
      },
      {
        path: 'material',
        name: 'adminMaterial',
        component: () => import('@/admin/material/index.vue'),
        meta: { title: '素材管理', roles: ['admin', 'operationStaff'] },
      },
      {
        path: 'music_task',
        name: 'adminMusicTask',
        component: () => import('@/admin/musicTask/index.vue'),
        meta: { title: '音乐创作任务', roles: ['admin', 'operationStaff'] },
      },
      {
        path: 'ai_task',
        name: 'adminAiTask',
        component: () => import('@/admin/aiTask/index.vue'),
        meta: { title: 'AI演唱任务', roles: ['admin', 'operationStaff'] },
      },
      {
        path: 'package',
        name: 'adminPackage',
        component: () => import('@/admin/package/index.vue'),
        meta: { title: '套餐管理', roles: ['admin', 'operationStaff'] },
      },
      {
        path: 'order',
        name: 'adminOrder',
        component: () => import('@/admin/order/index.vue'),
        meta: { title: '订单管理', roles: ['admin', 'operationStaff'] },
      },
      {
        path: 'agreement',
        name: 'adminAgreement',
        component: () => import('@/admin/webConfig/agreement.vue'),
        meta: { title: '协议管理', roles: ['admin', 'operationStaff'] },
      },
      {
        path: 'inspiration',
        name: 'adminInspiration',
        component: () => import('@/admin/inspiration/index.vue'),
        meta: { title: '灵感管理', roles: ['admin', 'operationStaff'] },
      },
      {
        path: 'promptType',
        name: 'adminPromptType',
        component: () => import('@/admin/promptType/index.vue'),
        meta: { title: '提示词分类', roles: ['admin', 'operationStaff'] },
      },
      {
        path: 'prompt',
        name: 'adminPrompt',
        component: () => import('@/admin/prompt/index.vue'),
        meta: { title: '提示词列表', roles: ['admin', 'operationStaff'] },
      },
      {
        path: 'system_config',
        name: 'adminSystemConfig',
        component: () => import('@/admin/systemConfig/index.vue'),
        meta: { title: '系统配置', roles: ['admin'] },
      },
      {
        path: 'base_config',
        name: 'adminBaseConfig',
        component: () => import('@/admin/webConfig/baseConfig.vue'),
        meta: { title: '基础配置', roles: ['admin', 'operationStaff'] },
      },
      {
        path: 'role',
        name: 'adminRole',
        component: () => import('@/admin/systemConfig/role.vue'),
        meta: { title: '角色管理', roles: ['admin', 'operationStaff'] },
      },
      {
        path: 'permission',
        name: 'adminPermission',
        component: () => import('@/admin/systemConfig/permission.vue'),
        meta: { title: '权限管理', roles: ['admin', 'operationStaff'] },
      },
      {
        path: 'rebate',
        name: 'adminRebate',
        component: () => import('@/admin/rebate/index.vue'),
        meta: { title: '佣金配置', roles: ['admin', 'operationStaff'] },
      },
      {
        path: 'rebate/history',
        name: 'adminRebateHistory',
        component: () => import('@/admin/rebateHistory/index.vue'),
        meta: { title: '提现记录', roles: ['admin', 'operationStaff'] },
      },
      {
        path: 'mvproject',
        name: 'adminMvProject',
        component: () => import('@/admin/mvProject/index.vue'),
        meta: { title: '视频管理', roles: ['admin', 'operationStaff'] },
      },
      {
        path: 'exportmv',
        name: 'adminExportMv',
        component: () => import('@/admin/exportMv/index.vue'),
        meta: { title: '合成视频', roles: ['admin', 'operationStaff'] },
      },
      {
        path: 'segment',
        name: 'adminSegment',
        component: () => import('@/admin/segment/index.vue'),
        meta: { title: '分镜视频', roles: ['admin', 'operationStaff'] },
      },
      {
        path: 'mv_task',
        name: 'adminMvTask',
        component: () => import('@/admin/mvTask/index.vue'),
        meta: { title: '视频创作任务', roles: ['admin', 'operationStaff'] },
      },
      {
        path: 'platforms',
        name: 'adminPlatforms',
        component: () => import('@/admin/systemConfig/platforms.vue'),
        meta: { title: '三方配置', roles: ['admin', 'operationStaff'] },
      },
    ],
  },
]

// 动态路由
export const asyncRoutes: RouteRecordRaw[] = [
  // ... 其他动态路由
]

const router = createRouter({
  history: createWebHistory(),
  routes: constantRoutes,
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const userStore = useUserStoreHook()
  // 切换路由时滚动到顶部
  window.scrollTo(0, 0)

  // 检查是否存在需要的角色权限
  if (to.meta.roles) {
    const requiredRoles = to.meta.roles as string[]
    // 检查是否需要管理员权限
    if (
      requiredRoles.includes(UserRoleEnum.Admin) ||
      requiredRoles.includes(UserRoleEnum.OperationStaff)
    ) {
      // 检查用户是否登录且是否是管理员
      if (
        userStore.isLogin &&
        (userStore.roles.includes(UserRoleEnum.Admin) ||
          userStore.roles.includes(UserRoleEnum.OperationStaff))
      ) {
        next()
      } else {
        // 不是管理员，显示错误信息并跳转到首页
        message.error('您没有管理员权限')
        next({ path: '/' })
      }
    }
    // 检查是否需要普通用户权限
    else if (requiredRoles.includes('user')) {
      // 已登录，允许访问
      if (userStore.isLogin) {
        next()
      } else {
        // 未登录，跳转到登录页
        message.info('请先登录')
        next({
          path: '/login',
          query: { redirect: to.fullPath }, // 保存原目标路径
        })
      }
    } else {
      // 其他角色要求，直接放行
      next()
    }
  } else {
    // 不需要登录权限的路由直接放行
    next()
  }
})

export default router
